import moment from "moment";
import { PunchEntry } from "../service/backend-service";

export class TimeUtils {

    static timeWorked(punch: PunchEntry): string {
        let totalMinutes = moment(punch.end).diff(moment(punch.start), 'minutes');
        return TimeUtils.minutesToFormattedHoursAndMinutes(totalMinutes);
    }

    static totalPunchesTime(toSum: Array<PunchEntry>): string {
        let completePunches = toSum.filter(entry => !!entry.end);

        // Only sumarize if there is entries complete
        if (completePunches.length === 0) {
            return '0';
        }

        let duration = completePunches
            .map(entry => moment.duration(moment(entry.end).diff(moment(entry.start))))
            .reduce((previous, current) => previous.add(current));

        return TimeUtils.minutesToFormattedHoursAndMinutes(duration.asMinutes());
    }

    private static minutesToFormattedHoursAndMinutes(totalMinutes: number): string {
        let hours = (totalMinutes / 60);
        let hourString = hours < 10 ? '0' + Math.trunc(hours) : '' + Math.trunc(hours);

        let minutes = totalMinutes % 60;
        let minuteString = minutes < 10 ? '0' + minutes.toFixed() : '' + minutes.toFixed();
        return hourString + ':' + minuteString;
    }
}